/** Case- and accent-insensitive form of a text for matching: „Rückruf“ → „ruckruf“. */
export function foldText(value: string): string {
  return value.normalize('NFD').replace(/\p{M}/gu, '').toLowerCase();
}
